import { useState } from "react";
import PropTypes from "prop-types";
import { Info, CreditCard } from "lucide-react";
import { Loader } from "components/Loader";
import {
  PlanConfirmationModalContainer,
  TitleRow,
  TitleIcon,
  Title,
  InfoBox,
  InfoIcon,
  InfoText,
  PlanNameHighlight,
  DetailRow,
  DetailLabel,
  DetailValue,
  Divider,
  Actions,
  CancelButton,
  ConfirmButton,
} from "./PlanConfirmationModal.styles";

export const PlanConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  planName,
  duration,
  isFree = false,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirm = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      await onConfirm();
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (isSubmitting) return;
    onHide();
  };

  const infoMessage = isFree
    ? "You are about to switch to the"
    : "You are about to subscribe to the";

  const paymentNote = isFree
    ? ""
    : " You will be redirected to complete payment.";

  return (
    <PlanConfirmationModalContainer
      show={show}
      onHide={handleClose}
      backdrop="static"
    >
      <TitleRow>
        <TitleIcon>
          <CreditCard size={20} />
        </TitleIcon>
        <Title>Confirm {isFree ? "Plan Change" : "Subscription"}</Title>
      </TitleRow>

      <InfoBox>
        <InfoIcon>
          <Info size={17} />
        </InfoIcon>
        <InfoText>
          {infoMessage} <PlanNameHighlight>{planName}</PlanNameHighlight> plan
          {duration ? ` (${duration})` : ""}.{paymentNote}
        </InfoText>
      </InfoBox>

      <DetailRow>
        <DetailLabel>Plan</DetailLabel>
        <DetailValue>{planName}</DetailValue>
      </DetailRow>

      {duration && (
        <DetailRow>
          <DetailLabel>Billing</DetailLabel>
          <DetailValue>
            {duration === "yearly" ? "Annually" : "Monthly"}
          </DetailValue>
        </DetailRow>
      )}

      <Divider />

      <Actions>
        <CancelButton
          type="button"
          onClick={handleClose}
          disabled={isSubmitting}
        >
          Cancel
        </CancelButton>
        <ConfirmButton
          type="button"
          onClick={handleConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? (
            <Loader className="on-btn" />
          ) : isFree ? (
            "Confirm"
          ) : (
            "Subscribe"
          )}
        </ConfirmButton>
      </Actions>
    </PlanConfirmationModalContainer>
  );
};

PlanConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  planName: PropTypes.string,
  duration: PropTypes.string,
  isFree: PropTypes.bool,
};
